const customMixins = {
  mainMobileNavBarOffset: 6.25,
  zIndex: {
    sidebar: 100,
    header: 100,
  },
};

export default customMixins;
